import commonActionTypes from '../actionTypes/common.actionTypes'
import { AppDispatch } from '../store'
import { TimeZone } from '../util/dateTime'
import { RecentExpression, StrategyExpressionMetaDataType } from '../reducer/common.reducer'
import { TimeBucket } from '../proto/generated/common'
import { WidgetListItems } from '../util/sidebar'
import { OptionChainViewKey, ViewType } from '../assets/constants'
import { OptionChainTableView } from '../pages/home/fnoHeader/optionsChainSettingsDialog'

const dispatchTimeZone = (dispatch: AppDispatch, timezone: TimeZone) => {
    dispatch({
        type: commonActionTypes.SET_TIME_ZONE,
        payload: timezone
    })
}

const toggleTheme = (dispatch: AppDispatch) => {
    dispatch({
        type: commonActionTypes.TOGGLE_THEME,
        payload: ''
    })
}
const setThemeMode = (dispatch: AppDispatch, mode: 'Light' | 'Dark' | 'System') => {
    document?.body?.classList?.add("disable-transition")
    setTimeout(() => document?.body?.classList?.remove("disable-transition"), 1000)

    dispatch({
        type: commonActionTypes.SET_THEME_MODE,
        payload: mode
    })

    if (mode === 'System') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: Dark)').matches;
        dispatch({ type: commonActionTypes.TOGGLE_THEME, payload: prefersDark });
    }
};

const dispatchRightSideWidget = (dispatch: AppDispatch, rightSideWidget: WidgetListItems | null) => {
    dispatch({
        type: commonActionTypes.SET_RIGHT_SIDE_WIDGET,
        payload: rightSideWidget
    })
}

const saveOptionSelectedColumns = (dispatch: AppDispatch, data: {
    columns: string[],
    optionChainViewKey: OptionChainViewKey,
    type: 'normal' | 'extended'
}) => {
    dispatch({
        type: commonActionTypes.SAVE_OPTION_SELECTED_COLUMN,
        payload: data
    })
}
const dispatchWatchlistId = (dispatch: AppDispatch, id: string | undefined) => {
    dispatch({
        type: commonActionTypes.SET_SELECTECED_WATCHLIST_ID,
        payload: id
    })
}

const dispatchShowOverviewChart = (dispatch: AppDispatch, showChart: boolean) => {
    dispatch({
        type: commonActionTypes.SHOW_OVERVIEW_CHART,
        payload: showChart
    })
}

const updateStrategyExpressionMetaData = (dispatch: AppDispatch, expression: StrategyExpressionMetaDataType) => {
    dispatch({
        type: commonActionTypes.ADD_OR_UPDATE_STRATEGY_EXPRESSION_METADATA,
        payload: expression
    })
}

const dispatchVolumeRemoved = (dispatch: AppDispatch, removed: boolean) => {
    dispatch({
        type: commonActionTypes.VOLUME_INDICATOR_REMOVED,
        payload: removed
    })
}

const setOverviewIndexComponentsSortedBy = (dispatch: AppDispatch, result: string) => {
    dispatch({
        type: commonActionTypes.SET_OVERVIEW_INDEX_COMPONENTS_SORTED_BY,
        payload: result
    })
}

const dispatchSelectedColumnSet = (dispatch: AppDispatch, selectedColumnSet: string) => {
    dispatch({
        type: commonActionTypes.SAVE_SCREENER_SELECTED_COLUMN_SET,
        payload: selectedColumnSet
    })
}

const setApiError = (dispatch: AppDispatch, payload: {
    error: boolean,
    message: string,
    errorType: 'error' | 'success' | 'info' | 'warning'
}) => {
    dispatch({
        type: commonActionTypes.SET_API_ERROR,
        payload: payload
    })
}

const saveRecentExpressions = (dispatch: AppDispatch, payload: RecentExpression[]) => {
    dispatch({
        type: commonActionTypes.SAVE_INTO_RECENT_EXPRESSIONS,
        payload: payload.sort((a, b) => b.lastUsedTime - a.lastUsedTime).slice(0, 10)
            .map((expression) => ({
                ...expression,
                securities: expression.securities.map((sec) => ({
                    code: sec.code,
                    exchange: sec.exchange,
                    symbol: sec.symbol
                }))
            }))
    })
}

const saveRecentExpressionsRefreshedTime = (dispatch: AppDispatch, time: number) => {
    dispatch({
        type: commonActionTypes.SAVE_RECENT_EXPRESSIONS_REFRESHED_TIME,
        payload: time
    })
}

const deleteRecentExpression = (dispatch: AppDispatch, expression: string) => {
    dispatch({
        type: commonActionTypes.DELETE_RECENT_EXPRESSION,
        payload: expression
    })
}

const setUserId = (dispatch: AppDispatch, userId: string) => {
    dispatch({
        type: commonActionTypes.SET_USER_ID,
        payload: userId
    })
}

const setNavigationUrl = (dispatch: AppDispatch, navigation: { viewType: ViewType, url: string }) => {
    dispatch({
        type: commonActionTypes.SET_NAVIGATION_URL,
        payload: navigation
    })
}

export const setMultiPaneFullScreen = (isFullScreen: boolean) => ({
    type: commonActionTypes.MULTI_PANE_FULLSCREEN,
    payload: isFullScreen
})
export const setWidgetsPaneId = (paneId: number | null) => ({
    type: commonActionTypes.SET_WIDGETS_PANE_ID,
    payload: paneId
})
export const toggleFullscreen = () => ({
    type: commonActionTypes.TOGGLE_FULLSCREEN
})

const setOptionChainVisibleStrikes = (dispatch: AppDispatch, optionChainVisibleStrikes: string) => {
    dispatch({
        type: commonActionTypes.SET_OPTION_CHAIN_VISIBLE_STRIKES,
        payload: optionChainVisibleStrikes
    })
}

const setOptionChainTableView = (dispatch: AppDispatch, tableView: OptionChainTableView) => {
    dispatch({
        type: commonActionTypes.SET_OPTION_CHAIN_TABLE_VIEW,
        payload: tableView
    })
}

const setOptionChainQuantityInLots = (dispatch: AppDispatch, showQuantityInLots: boolean) => {
    dispatch({
        type: commonActionTypes.SET_OPTION_CHAIN_QUANTITY_IN_LOTS,
        payload: showQuantityInLots
    })
}





const setOptionChainTimeInterval = (dispatch: AppDispatch, timeBucket: {
    timeBucket: TimeBucket,
    optionChainViewKey: OptionChainViewKey,
    type: 'normal' | 'extended'
}) => {
    dispatch({
        type: commonActionTypes.SET_OPTION_CHAIN_TIMEBUCKET,
        payload: timeBucket
    })
}

const setOptionChainMirrorScroll = (dispatch: AppDispatch, data: {
    isMirrorScroll: boolean,
    optionChainViewKey: OptionChainViewKey,
    type: 'normal' | 'extended'
}) => {
    dispatch({
        type: commonActionTypes.SET_OPTION_CHAIN_MIRROR_SCROLL,
        payload: data
    })
}

const addCustomColor = (dispatch: AppDispatch, color: string) => {
    dispatch({
        type: commonActionTypes.ADD_CUSTOM_COLOR,
        payload: color
    })
}


const commonActions = {
    dispatchTimeZone,
    toggleTheme,
    setThemeMode,
    dispatchWatchlistId,
    saveOptionSelectedColumns,
    dispatchRightSideWidget,
    dispatchShowOverviewChart,
    dispatchVolumeRemoved,
    setUserId,
    setOverviewIndexComponentsSortedBy,
    setApiError,
    dispatchSelectedColumnSet,
    saveRecentExpressions,
    saveRecentExpressionsRefreshedTime,
    deleteRecentExpression,
    updateStrategyExpressionMetaData,
    setNavigationUrl,
    setMultiPaneFullScreen,
    setWidgetsPaneId,
    toggleFullscreen,
    setOptionChainVisibleStrikes,
    setOptionChainTableView,
    setOptionChainQuantityInLots,
    setOptionChainTimeInterval,
    setOptionChainMirrorScroll,
    addCustomColor
}

export default commonActions